import React from 'react';
import { Box, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { getTemperatureInfo } from '../../utils/temperatureUtils';
import { chartStatisticsStyles } from './styles';
import type { ChartStatisticsProps } from './types';
import FormattedAlias from '@components/_shared/Translations/FormattedAlias';

const ChartStatistics: React.FC<ChartStatisticsProps> = React.memo(
  ({ statistics, currentTemperature }) => {
    const theme = useTheme();
    const currentTempInfo = getTemperatureInfo(currentTemperature, theme);

    return (
      <Box sx={chartStatisticsStyles.container(theme)}>
        <Typography variant='body2' color='text.secondary'>
          <strong style={chartStatisticsStyles.labelStyle(theme)}>
            <FormattedAlias id='Min' />:
          </strong>{' '}
          {statistics.min.toFixed(1)}°C
        </Typography>
        <Typography variant='body2' color='text.secondary'>
          <strong style={chartStatisticsStyles.labelStyle(theme)}>
            <FormattedAlias id='Max' />:
          </strong>{' '}
          {statistics.max.toFixed(1)}°C
        </Typography>
        <Typography variant='body2' color='text.secondary'>
          <strong style={chartStatisticsStyles.labelStyle(theme)}>
            <FormattedAlias id='Avg' />:
          </strong>{' '}
          {statistics.avg.toFixed(1)}°C
        </Typography>
        <Typography variant='body2' color='text.secondary'>
          <strong style={chartStatisticsStyles.labelStyle(theme)}>
            <FormattedAlias id='Median' />:
          </strong>{' '}
          {statistics.median.toFixed(1)}°C
        </Typography>
        {currentTemperature !== undefined && currentTemperature !== null && (
          <Typography
            variant='body2'
            sx={chartStatisticsStyles.currentTemperature(
              currentTempInfo?.color,
              theme,
            )}
          >
            <FormattedAlias id='Current' />: {currentTemperature.toFixed(1)}°C
          </Typography>
        )}
        <Typography
          variant='caption'
          color='text.disabled'
          sx={chartStatisticsStyles.dataPointsCaption}
        >
          <FormattedAlias
            id='{count} data points'
            values={{ count: statistics.count }}
          />
        </Typography>
      </Box>
    );
  },
  (prevProps, nextProps) => {
    return (
      prevProps.statistics.min === nextProps.statistics.min &&
      prevProps.statistics.max === nextProps.statistics.max &&
      prevProps.statistics.avg === nextProps.statistics.avg &&
      prevProps.statistics.median === nextProps.statistics.median &&
      prevProps.statistics.count === nextProps.statistics.count &&
      prevProps.currentTemperature === nextProps.currentTemperature
    );
  },
);

ChartStatistics.displayName = 'ChartStatistics';

export default ChartStatistics;
